let blogs_on_page = $('.blogs-on-page')
var next_url = blogs_on_page.data('next-url')
var load_more_btn = $('.load-more__btn')
var load_more_spinner = $('.load-more__spinner')
function loadMoreArticles(){
    $.ajax({
       url : next_url,
      type: 'GET',
      dataType : 'html',
      beforeSend: function(){
        load_more_btn.hide();
        load_more_spinner.show();
      }
  })
  .done(function(next_page){
    load_more_spinner.hide();
      var new_blogs = $(next_page).find('.blogs-on-page');
      var new_url = new_blogs.data('next-url');
      next_url = new_url;
      if(new_url){
        load_more_btn.show();
      }
      blogs_on_page.append(new_blogs.html())
  })
}